import { message } from 'antd';

import axiosWithAuth from '@/lib/axios';
import client from '@/lib/feathers';
import type { FixRecord } from '@/types/database/fixRecord';

import type { EditFixRecordProps, FixRecordFormValues } from './types';

export const handleSubmit = async ({
  values,
  fixId,
  editFixRecord,
  afterEdit,
}: {
  values: FixRecordFormValues;
  fixId: string;
  editFixRecord: EditFixRecordProps['editFixRecord'];
  afterEdit: () => void;
}) => {
  const { user } = await client.reAuthenticate();
  const { image, ...restValues } = values;
  const uploadData: Omit<FixRecord, '_id' | 'createdTime'> = {
    repairerName: restValues.repairerName,
    content: restValues.content,
    repairedTime: restValues.repairedTime.toISOString(),
    creatorName: user.name,
    fixId,
    image: null,
    status: restValues.status,
  };
  try {
    if (image?.[0]?.originFileObj) {
      const formData = new FormData();
      formData.append('files', image[0].originFileObj);
      const { data } = await axiosWithAuth.post(
        '/newUploads?type=fixRecords',
        formData
      );
      uploadData.image = {
        name: image[0].name,
        path: data?.[0]?.showPath,
      };
    } else if (image?.[0]?.url) {
      uploadData.image = {
        name: image[0].name,
        path: image[0].url,
      };
    }
    if (editFixRecord.fixRecord) {
      await axiosWithAuth.patch(
        `/ezcon/api/fixRecords/${editFixRecord.fixRecord._id}`,
        uploadData
      );
      message.success('編輯成功');
    } else {
      await axiosWithAuth.post('/ezcon/api/fixRecords', uploadData);
      message.success('新增成功');
    }
    afterEdit();
  } catch (error) {
    console.error(error);
    message.error('發生錯誤');
  }
};
